import { Row, Col } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import Input from 'common/components/form/styled-inputs/Input';
import { FormState } from 'common/entities/form/FormTypes';
import ListSelect from 'common/components/selectors/ListSelect';
import Checkbox from 'common/components/form/inputs/Checkbox';
import ColorInput from 'common/components/form/inputs/ColorInput';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';
import UploadFiles from '@/library/components/form/inputs/upload-files';

import GroupField from '../components/GroupField';

const Item = ({ formState, drawer }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <Row>
      <Col xs={12} className="mb-1">
        {drawer?.isOpen ? (
          <GroupField onChange={selectField('store_group')} storeGroup={fields?.store_group} />
        ) : null}
      </Col>

      <Col xs={6}>
        <Input
          label="Code"
          invisible={false}
          placeholder={'Add code'}
          className="mb-2 mt-1"
          onChange={changeField('code')}
          {...fields.code}
        />
      </Col>

      <Col xs={12} className="mb-2">
        <Input
          label="Name"
          invisible={false}
          placeholder={'Add name'}
          onChange={changeField('description')}
          {...fields.description}
        />
      </Col>

      <Col xs={6}>
        <ListSelect
          label="Unit"
          list="purchasing-units"
          placeholder="Select unit"
          onChange={selectField('purchasing_unit_id')}
          {...fields.purchasing_unit_id}
        />
      </Col>

      <Col className="d-flex align-items-center">
        <Checkbox
          label={<div className="fs-12">IHM Related</div>}
          value={fields.ihm_related.value}
          onChange={() => selectField('ihm_related')(!fields.ihm_related.value)}
          className="text-primary cmb-2"
        />
      </Col>

      <Col xs={6}>
        <Input
          label="Color"
          invisible={false}
          placeholder={'Add name'}
          onChange={changeField('color_name')}
          {...fields.color_name}
        />
      </Col>

      <Col xs={6}>
        <ColorInput
          label="Hex Color"
          invisible={false}
          onChange={changeField('color_hex_code')}
          {...fields.color_hex_code}
        />
      </Col>

      <Col xs={12} className="border-top border-platinum pt-4 mt-4">
        <UploadFiles
          label=""
          group="stores"
          files={fields.photo.value ? fields.photo.value : []}
          onChange={files => selectField('photo')(files)}
          singleUpload={true}
          size="lg"
          {...fields.photo}
        />
      </Col>
    </Row>
  );
};

export default Item;

Item.propTypes = {
  formState: FormState,
  drawer: DrawerState.isRequired
};
